import { call, put, takeLatest } from "redux-saga/effects";
import { PettyCashierMonthlyBudgetReviewAction } from "../../../actions";
import * as types from "../../../actions/actionTypes";
import * as monthlyBudgetReviewApi from "../../../api/monthlyBudget/review/pettyCashierMonthlyBudgetReview";
import {SetMessage} from "../../../assets/errorMessages";

export function* pettyCashierWatcherMonthlyBudgetReview() {
  yield takeLatest(
    types.PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_REQUEST,
    worker
  );
}

async function fetch() {
  return monthlyBudgetReviewApi.get();
}

function* worker() {
  try {
    const response = yield call(fetch);
    yield put(PettyCashierMonthlyBudgetReviewAction.getSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierMonthlyBudgetReviewAction.getFailure(message));
  }
}
